import React from 'react';

function Footer() {
    return (
        <footer className="bg-dark text-white text-center py-3">
        <p> مناحل المراد ، جميع الحقوق محفوظة &copy; {new Date().getFullYear()} </p>
        <p> لتصميم موقعك الإلكتروني الخاص يرجى التواصل على الايميل التالي :</p>
        <p>abdoalmorad1995@gmail.com</p>
        </footer>
    );
    }

export default Footer;
